/*
  Main 관리 (2018/06/01 정재윤)
    - App Ready 상태 확인
    - Vue 인스턴스 생성
    - App.vue 로딩
*/

import '~core'
// import '@/_fdp/core/router/index.b2c'
import Router from '~fdp/core/router/router.js'
import rootRoutes from '@/config/router/rootRoutes'

import Toast from 'vue-toastification'

import './init'

import VueGtm from 'vue-gtm'
// import VueAnalytics from 'vue-analytics'

/* common module import */
import MmpUtilsPlugin from '@/plugins/_common/MmpUtils'
import MmpResourcePlugin from '@/plugins/_common/MmpResource'
import MmpPopupPlugin from '@/plugins/_common/MmpPopup'
import MmpVeeValidate from '@/plugins/_common/MmpVeeValidate'
import VueLoadScript from '@/plugins/_common/VueLoadScript'
import MmpPostMessage from '@/plugins/_common/MmpPostMessage'
import VueSwiper from '@/plugins/_common/VueSwiper'
import MmpBeforeRouteCheck from '@/plugins/_common/MmpBeforeRouteCheck'
import MmpLoading from '@/plugins/_common/MmpLoading'

import MmpToast from '@/components/_common/mmp-toast/MmpToast.vue'

import globalMixins from '@/mixin/globalMixin'
import MmpMessagePlugin from '@/plugins/_common/MmpMessage'

import Vue from 'vue'
import App from './App/App'

import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
if (window.vue.config.app.isCssLoaded === undefined) { window.vue.config.app.isCssLoaded = false }

// Vue 인스턴스 생성
const locale = localStorage.getItem('language') || window.vue.config.app.defaultLocale

// load http module

Vue.use(MmpResourcePlugin)
Vue.mixin(globalMixins)

window.vue.setLocaleResource(locale)
  .then(() => {
    // success
  }).catch((error) => {
    // fail
    console.error(error)
    window.vue.setLocale(locale)
  }).finally(() => {
    createVue()
  })

const createVue = async () => {
  /* common module install */
  Vue.use(MmpUtilsPlugin)

  // let httpObj = window.vue.getInstance('http')
  await rootRoutes.generateRouter(Router)

  // document.getElementById('app').classList.remove('lds-roller')

  /* common module install */
  Vue.use(MmpPopupPlugin)
  Vue.use(MmpVeeValidate)
  Vue.use(VueLoadScript)
  Vue.use(MmpPostMessage)
  Vue.use(VueSwiper)
  Vue.use(MmpLoading)

  let isPhone = Vue.utils.userAgent.isPhone()
  let isTablet = Vue.utils.userAgent.isTablet()
  let isDesktop = Vue.utils.userAgent.isDesktop()
  let isApp = Vue.utils.userAgent.isApp()

  var routerObj = window.vue.getInstance('router')

  console.log('router ', routerObj)
  console.log('userAgent', 'isPhone: ', isPhone ? 'O' : 'X', 'isTablet:', isTablet ? 'O' : 'X', 'isDesktop', isDesktop ? 'O' : 'X', 'isApp', isApp ? 'O' : 'X')

  Vue.use(MmpBeforeRouteCheck)

  // Vue.use(VueAnalytics, {
  //   id: 'GTM-NC3K5VK',
  //   router: routerObj,
  //   checkDuplicatedScript: true
  // })
  let isNrwMobile = window.vue.getStore('mmpAuth').getters.isNrwMobile
  Vue.use(VueGtm, {
    id: isNrwMobile ? 'GTM-NL3KD4HQ' : 'GTM-NC3K5VK', // 변경시 왼쪽 항목 수정할것
    vueRouter: routerObj,
    loadScript: true,
    debug: true,
    enable: true
  })

  var MmpToastContainer = Vue.extend(MmpToast)

  var toastContainer = new MmpToastContainer().$mount()
  document.body.appendChild(toastContainer.$el)

  Vue.use(Toast, {
    container: toastContainer.$el
  })

  Vue.use(VueLazyload)
  Vue.use(MmpMessagePlugin)

  if (window.vue.getInstance('vue') === undefined) {
    const vueInstance = new Vue({
      el: '#app',
      components: { App },
      i18n: window.vue.getI18n(),
      router: routerObj,
      render: function (createElement) {
        return createElement(App)
      }
    })
    window.vue.setInstance('vue', vueInstance)
  }
}

// console.log 출력 안 되게 하는 스크립트 production
if (process.env.NODE_ENV === 'production') {
  const muteFunc = function () {}
  window.console.log = muteFunc
  console.log = muteFunc
  console.info = muteFunc
}



// WEBPACK FOOTER //
// ./src/main.js